// ----------------------------------------------------------------
// 2. Hook: hooks/useUpdateBookingStatusMark.ts
// ----------------------------------------------------------------
import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api"; // Sesuaikan path jika perlu
import { UpdateStatusMarkType } from "../schema/UpdateStatusMarkSchemaV4";

export const useUpdateBookingStatusMark = () => {
    return useMutation({
        mutationFn: async (values: {
            bookingId: string;
            formData: UpdateStatusMarkType;
        }) => {
            // Menggunakan method PATCH karena ini adalah update parsial
            const response = await privateApi.patch(
                `/v4/booking/${values.bookingId}/status-mark`,
                values.formData
            );
            return response.data;
        },
        onSuccess: (data) => {
            console.log("Status & mark updated successfully:", data);
            // Bisa ditambahkan logic untuk invalidasi query, notifikasi, dll.
            return data;
        },
        onError: (error: any) => {
            const errorMessage = error?.response?.data?.message || "Failed to update status & mark";
            console.error(errorMessage, error.response?.data || error);
            throw new Error(errorMessage);
        },
    });
};